import Vue from "vue";
import Http from "vue-resource";
import router from "./router";
import store from "./store";
import { VueMaskDirective } from "v-mask";
import Layout from "./shared/app-layout";
import { mapState } from "vuex";
import VueTheMask from "vue-the-mask";
import { registerGTM } from "./registerGTM";
import { registerMixpanel } from "./registerMixpanel";
import config, { initConfig } from "./config";
import { mask } from "vue-the-mask";
import { setupPreview } from "./preview";
import { directive as LangDirective, getTranslator, t } from "./languages";
import { getRouteLang, resolveInitialLang } from "./langPreference";

initConfig();
registerGTM();
registerMixpanel();

Vue.use(VueTheMask);
Vue.directive("mask", mask);
Vue.use(Http);

if (config.isPreview) {
    setupPreview();
}

Vue.directive("lang", LangDirective);

const translateForVm = (vm, term, replaces) => {
    const lang = vm?.$root?.lang || vm?.lang || getRouteLang(router.currentRoute) || "ptBr";
    return t(term, lang, replaces);
};

Vue.prototype.$_ = getTranslator("ptBr");
Vue.prototype.$t = function (term, replaces) {
    return translateForVm(this, term, replaces);
};
Vue.mixin({
    methods: {
        t(term, replaces) {
            return this.$t(term, replaces);
        },
    },
});

const App = new Vue({
    store,
    router: router,
    components: {
        Layout,
    },
    data: function () {
        return {
            lang: resolveInitialLang(router.currentRoute),
        };
    },
    computed: mapState({
        place: (state) => state.place,
    }),
    created() {
        this.applyLang(this.lang);
        this.syncLangFromRoute(this.$route);
        this.$store.dispatch("init");
    },
    methods: {
        applyLang(lang) {
            this.lang = lang;
            Vue.prototype.$_ = getTranslator(lang);
        },
        syncLangFromRoute(route) {
            const queryLang = getRouteLang(route);
            if (queryLang) {
                if (queryLang !== this.lang) {
                    this.applyLang(queryLang);
                }
                return;
            }

            if (this.lang !== "ptBr") {
                this.applyLang("ptBr");
            }
        },
    },
    watch: {
        $route: function (to) {
            this.syncLangFromRoute(to);
        },
        "place.name"() {
            document.getElementsByTagName("title")[0].innerText =
                this.place.name + " - Consulte Seus Pontos e Recompensas";
        },
    },
}).$mount("#app");
